import React, {useEffect, useState} from 'react';
import {getDatabase, onValue, ref} from "firebase/database";
import app from "../firebaseConfig/firebaseConfig";
import {useSearchParams} from "react-router";
import AdminOrderCard from "./Components/AdminOrderCard";
import FunctionHandler from "../utils/functionHandler";

const db = getDatabase(app);

function OrderPage(props) {
    const [order, setOrder] = useState();
    const [searchParams] = useSearchParams();
    const orderRefString = searchParams.get('ref');
    const placedOrderRefString = searchParams.get('placedOrderRef');

    useEffect(() => {
        if (!db) {
            return;
        }

        const orderRef = ref(db, decodeURIComponent(orderRefString));
        onValue(orderRef, (snapshot) => {
            setOrder(snapshot.val());
        });
    }, []);

    const submitStatus = (status) => {
        FunctionHandler.sendData('/changeOrderStatus', {
            orderRef: decodeURIComponent(orderRefString),
            placedOrderRef: decodeURIComponent(placedOrderRefString),
            status: status
        }, (data) => {
            console.log(data)
        });
    }

    return (
        <div className="orderspage">
            {order && <AdminOrderCard order={order} submitStatus={submitStatus}/>}
        </div>
    );
}

export default OrderPage;
